import {
  TrendingSearch,
  SearchSuggestion,
  PopularSuggestion,
  PopularSuggestionType,
} from 'types/searchSuggestion';
import { getSearchHistory } from 'helpers/utils/search/searchSuggestion';
import { searchTypes } from 'constants/searchSuggestion';

export interface SearchSuggestionFromAPI {
  url: string;
  id: string;
  q: string;
  type: string;
  click?: number;
  ctr?: number;
  score?: number;
  sss?: number;
  image_base?: string;
  image?: string;
  icon: string;
  subtext: string;
  match_count?: string;
  image_v2?: string;
  mweb_url?: string;
  store_type?: string;
}

/** Autosuggest API shape when results are split into labelled sections */
export interface SearchSuggestionGroup {
  type: string;
  suggestions: SearchSuggestionFromAPI[];
}

export const transformTrendingSearches = (
  trendingSearch: TrendingSearch[]
): TrendingSearch[] => trendingSearch;

export const transformPopularSuggestions = (popularSuggestions: any[]) => {
  const popularSuggestionTypes: PopularSuggestionType[] = [];
  Array.isArray(popularSuggestionTypes) &&
    popularSuggestions?.forEach((popularSuggestion) => {
      const popularSuggestionType = popularSuggestion.widget_data;
      const suggestions: PopularSuggestion[] = [];

      popularSuggestionType.children?.forEach((suggestion: any) => {
        const q = suggestion?.parameters?.app_link_data;
        const pageType = suggestion?.parameters?.app_link_type;
        const id = parseInt(suggestion?.parameters?.app_link_id);
        const url = `/${pageType}/${q}/c/${id}`;
        const type = popularSuggestionType?.parameters?.widget_title
          ?.toLocaleLowerCase()
          .replace(/\s/g, '-');
        suggestions.push({ q, url, id, type });
      });

      popularSuggestionTypes.push({
        q: popularSuggestionType.parameters.widget_title,
        id: popularSuggestionType.wid,
        suggestions: suggestions,
      });
    });
  return popularSuggestionTypes;
};

export const transformSearchSuggestions = (
  searchSuggestion: SearchSuggestionFromAPI[]
): SearchSuggestion[] =>
  searchSuggestion.map((suggestionObj: SearchSuggestionFromAPI) => {
    let {
      image_base: imageBase,
      match_count: matchCount,
      image_v2: imageV2,
      mweb_url: mwebUrl,
      store_type: storeType,
      ...rest
    } = suggestionObj;
    return { ...rest, imageBase, matchCount, imageV2, mwebUrl, storeType };
  });

export const sortSearchSuggestions = (searchSuggestion: SearchSuggestion[]) => {
  const searchItems = getSearchHistory();
  const suggestions: SearchSuggestion[] = [];
  const matchSuggestions: SearchSuggestion[] = [];
  searchSuggestion.forEach((suggestion) => {
    if (
      searchItems?.some(
        (item) => item.q?.toLowerCase() === suggestion.q?.toLowerCase()
      )
    ) {
      suggestion.icon = searchTypes.HISTORY;
      matchSuggestions.push(suggestion);
    } else {
      suggestions.push(suggestion);
    }
  });
  return [...matchSuggestions, ...suggestions];
};
